module.exports = __webpack_public_path__ + "img/618.b51283b0.png";